import { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';import "../../assets/styles/HR/HrLeavePg.css";

function HrLeavePg() {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [actionModal, setActionModal] = useState(null);
  const [comment, setComment] = useState('');

  const fetchLeaves = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getHrLeaveRequests();
      setLeaves(data || []);
    } catch (e) {console.error(e);} finally
    {setLoading(false);}
  }, []);

  useEffect(() => {fetchLeaves();}, [fetchLeaves]);

  const handleAction = async (action) => {
    if (!actionModal) return;
    try {
      await api.hrLeaveAction(actionModal.req_id, action, comment);
      setActionModal(null);
      setComment('');
      fetchLeaves();
    } catch (e) {alert(e.message);}
  };

  const filtered = leaves.filter((l) => {
    if (filter === 'pending') return l.hr_status === 'pending';
    if (filter === 'approved') return l.hr_status === 'approved';
    if (filter === 'rejected') return l.hr_status === 'rejected' || l.pm_status === 'rejected';
    return true;
  });

  const fmtDate = (d) => {
    if (!d) return '-';
    try {return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });}
    catch {return d;}
  };

  const statusChip = (status) => {
    const colors = { approved: '#3b82f6', rejected: '#ef4444', pending: '#f59e0b', waiting: '#94a3b8', not_required: '#cbd5e1', manager_approved: '#6366f1' };
    return <span style={{ "--hrleavepg-1-background": `${colors[status] || '#94a3b8'}20`, "--hrleavepg-1-color": colors[status] || '#94a3b8' }} className="hrleavepg-dyn-1">{status === 'manager_approved' ? 'PM Approved' : status || '-'}</span>;
  };

  return (
    <div>
      <div className="sec">Leave Management (PM → HR Hierarchy)</div>
      <div className="hrleavepg-inline-1">
        {['all', 'pending', 'approved', 'rejected'].map((f) =>
        <button key={f} onClick={() => setFilter(f)} style={{ "--hrleavepg-2-background":

          filter === f ? '#6366f1' : '#fff', "--hrleavepg-2-color":
          filter === f ? '#fff' : '#64748b', "--hrleavepg-2-border-color":
          filter === f ? '#6366f1' : '#e2e8f0' }} className="hrleavepg-dyn-2">
          {f.charAt(0).toUpperCase() + f.slice(1)} ({f === 'all' ? leaves.length : leaves.filter((l) => f === 'pending' ? l.hr_status === 'pending' : f === 'approved' ? l.hr_status === 'approved' : l.hr_status === 'rejected' || l.pm_status === 'rejected').length})</button>
        )}
      </div>

      {loading ? <div>Loading...</div> :
      <div className="cd">
          <table className="tbl hrleavepg-inline-2">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Role</th>
                <th>Type</th>
                <th>From</th>
                <th>To</th>
                <th>Days</th>
                <th>PM Status</th>
                <th>HR Status</th>
                <th>Overall</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((l) =>
            <tr key={l.req_id || l.id}>
                  <td className="hrleavepg-inline-3">{l.name || '-'}</td>
                  <td><span className="hrleavepg-inline-4">{l.user_role || '-'}</span></td>
                  <td>{l.leave_type || '-'}</td>
                  <td>{fmtDate(l.from_date)}</td>
                  <td>{fmtDate(l.to_date)}</td>
                  <td className="hrleavepg-inline-5">{l.days}</td>
                  <td>{statusChip(l.pm_status)}</td>
                  <td>{statusChip(l.hr_status)}</td>
                  <td>{statusChip(l.status)}</td>
                  <td>
                    {l.hr_status === 'pending' ?
                <div className="hrleavepg-inline-6">
                        <button onClick={() => setActionModal(l)} className="hrleavepg-inline-7">Review</button>
                      </div> :
                <span className="hrleavepg-inline-8">Done</span>}
                  </td>
                </tr>
            )}
              {filtered.length === 0 && <tr><td colSpan={10} className="hrleavepg-inline-9">No leave requests</td></tr>}
            </tbody>
          </table>
        </div>
      }

      {/* Action Modal */}
      {actionModal &&
      <div className="hrleavepg-inline-10">
          <div className="hrleavepg-inline-11">
            <h3 className="hrleavepg-inline-12">Leave Request - {actionModal.name}</h3>
            <div className="hrleavepg-inline-13">
              <p><strong>Type:</strong> {actionModal.leave_type} | <strong>Days:</strong> {actionModal.days}</p>
              <p><strong>From:</strong> {fmtDate(actionModal.from_date)} → <strong>To:</strong> {fmtDate(actionModal.to_date)}</p>
              <p><strong>PM Decision:</strong> {statusChip(actionModal.pm_status)}</p>
              <p><strong>Reason:</strong> {actionModal.reason || '-'}</p>
            </div>
            <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Comment (optional)" rows={3} className="hrleavepg-inline-14" />
            <div className="hrleavepg-inline-15">
              <button onClick={() => setActionModal(null)} className="hrleavepg-inline-16">Cancel</button>
              <button onClick={() => handleAction('rejected')} className="hrleavepg-inline-17">Reject</button>
              <button onClick={() => handleAction('approved')} className="hrleavepg-inline-18">Approve</button>
            </div>
          </div>
        </div>
      }
    </div>);

}

export default HrLeavePg;